import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../utils";
import { ReactComponent as ViewIcon } from "../../Icons/totalView.svg";
import { useSelector } from "react-redux";
import { ReactComponent as InternalIcon } from "../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Button2 from "../../NewComponent/Button2/Button2";
import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";

export default function NameInfo({ data, question }) {
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const onCLickFavorite = () => {
  };
  const userProfile = () => {
    let img = "";
    img = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === data.expertUuid
    );
    if (img !== undefined) {
      return `data:image/JPEG;base64,${img.img}`;
    }
  };
  userProfile();
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
          {arr.map((item, index) => (
            <div className="mb-1">
              {" "}
              <AttachmentBox key={index} attachment={item} />
            </div>
          ))}
      </div>
    );
  };


  return (
    <>
      <div style={infoContainer}>
        <div>
            {<Avatar
              size={48}
              src={data.expertFirstName !== 'Vizerto' ? (userProfile() || require("../../Images/cliente.png")) : require("../../Images/bot-icon.png")}
            ></Avatar>}
          {/* {data.expert.expertFirstName === "Vizerto" && (
            <Avatar
              size={48}
              src={require("../../Images/bot-icon.png")}
            ></Avatar>
          )} */}
        </div>
        <div style={dateInfoStyles}>
          <div>
            {question.docType === "expertqa" && (
              <div style={textStyles}>
                {data.expert.firstName} {data.expert.lastName}
              </div>
            )}
            {question.docType !== "expertqa" && (
              <div style={textStyles}>
                {question.docName === "" || question.docName === undefined
                  ? `${data.expertFirstName} ${data.expertLastName}`
                  : question.docName}
              </div>
            )}
            <div style={dateStyles}>
              {(data.answeredTimestamp < data.answerUpdatedTimestamp
                && data.answerStatus !== 'accepted') ? "Last reviewed"
                : data.answeredTimestamp >= data.answerUpdatedTimestamp && data.answerStatus !== 'accepted' ? "Answered" : ""}
              {data.answerStatus === "accepted" && "Viewed"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.answerUpdatedTimestamp
                  ? data.answerUpdatedTimestamp
                  : data.answeredTimestamp
              )}
            </div>
          </div>
          <div style={infoContainer}>
            {data.popularityScore !== null &&
              data.popularityScore !== undefined && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    // fontWeight: "500",
                  }}
                >
                  <TooltipComp title={"Total view count"}>
                                                                                                            <ViewIcon /> 
                                                                                                          </TooltipComp>
                  &nbsp;{data.popularityScore}&nbsp;&nbsp;
                </span>
              )}
            {data.internal && (
              <div style={{ marginRight: "6px" }}>
               <TooltipComp title={"Internal Answer"}>
                                                               <InternalIcon /> 
                                                             </TooltipComp>
              </div>
            )}
            {
              data.privacy && (
                <div style={{ marginRight: "6px" }}>
                  {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" width="16" height="18">
                    <path d="M400 224h-24v-72C376 68.1 307.9 0 224 0S72 68.1 72 152v72H48C21.5 224 0 245.5 0 272v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-80 0H128v-72c0-52.9 43.1-96 96-96s96 43.1 96 96v72z" />
                  </svg> */}
                  <i className="fa fa-lock" style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "20px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    fontWeight: "500",
                  }}></i>
                </div>
              )
            }
            {
              data.attachments &&
              data.attachments.length > 0 && (
                <div style={{  }}>
                  <Popover title={renderAttachemnt(data.attachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
              {/* {!data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      data.curationCategory === 1 &&
                        data.curationStatus === "pending" &&<div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{fontSize:'22px', color:'#F59B00', marginLeft:'5px'}}></i></span></TooltipComp>
              </div>} */}
          </div>
        </div>
      </div>
    </>
  );
}
